import React, { useState } from 'react'
import { Breadcrumb, Card, Button } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InboxOutlined } from '@ant-design/icons'
import { faCogs, faHome, faVideo } from '@fortawesome/free-solid-svg-icons';
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { settingAlert, settingResponse, settings, settingsRefresh } from '../../../states/settings';
import { Input, Form, Button as AntButton, Modal, Upload } from 'antd';
import AlertToast from '../../../components/AlertToast';
import { createTermConditionModal, termPolicy } from '../../../states/termCondition';
import HowItWorkModal from './Modal';
import Table from './Table';

const Policy = () => {
  const data = useRecoilValueLoadable(settings)
  const dataList = useRecoilValueLoadable(termPolicy)
  const [showAlert, setShowAlert] = useRecoilState(settingAlert);
  const [response, setResponse] = useRecoilState(settingResponse)
  const setRefresh = useSetRecoilState(settingsRefresh)
  const setCreateModal = useSetRecoilState(createTermConditionModal);
  const settingData = data.state === "hasValue" ? data.contents : {}
  const howItWorkData = dataList.state === "hasValue" && dataList.contents ? dataList.contents : []
  const [form] = Form.useForm()

  return (
    <div>
      <AlertToast showAlert={showAlert} setShowAlert={setShowAlert} response={response} page="Privacy Policy" />
      <HowItWorkModal />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Waya pay</Breadcrumb.Item>
            <Breadcrumb.Item active>Privacy Policy</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Privacy Policy Page</h4>
        </div>
      </div>
      <div className="table-settings mb-4">
        <Button variant="success" className="text-white me-3" onClick={() => setCreateModal(true)}>
          Create New Policy <FontAwesomeIcon icon={faCogs} className="d-none d-sm-inline ms-1" />
        </Button>
      </div>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          <h5 className="mb-4 text-primary">Privacy Policy</h5>
          
          <Table data={howItWorkData} />
        </Card.Body>
      </Card>

      {/* How it work video end */}
    </div>
  )
}

export default Policy
